export enum CriticalTransmissionStatus {
  Trapped = 'Held - Bad Data',
  SendBeforeCutoff = 'Held for Invoice to be resent',
  BadData = 'Held - Bad Data',
}
